import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const PACKAGE_SELECTION_MAX_WIDTH = 1920

/** Bounds the comparison surface while its parent owns the full-bleed background. */
const AccommodationPackageSelectionContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: ${rem(PACKAGE_SELECTION_MAX_WIDTH)};
  margin-inline: auto;
  padding-inline: 0;

  ${mediaQueryUp.tablet} {
    padding-inline: ${rem(16)};
  }
`

export default AccommodationPackageSelectionContainer
